import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const availabilityClass = (value) => {
  if (value === 'Available') return 'bg-emerald-50 text-emerald-700';
  if (value === 'Blocked') return 'bg-red-50 text-red-700';
  return 'bg-gray-100 text-gray-600';
};

const OutsideStructureDrawer = ({ run, locations = [], onSelectLocation, onClose }) => {
  if (!run) return null;
  const shelvingGroups = locations.filter((location) => location.placement?.structure === 'shelving').reduce((groups, location) => {
    const section = location.placement.section;
    groups.set(section, [...(groups.get(section) || []), location]);
    return groups;
  }, new Map());
  const genericLocations = locations.filter((location) => location.placement?.structure !== 'shelving');
  return (
    <aside className="absolute inset-y-0 right-0 z-30 flex w-[380px] flex-col border-l border-gray-200 bg-white shadow-xl">
      <div className="flex items-start justify-between border-b border-gray-200 px-3 py-2.5">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-widest text-gray-400">Outside approved structure</p>
          <h3 className="mt-0.5 text-[16px] font-semibold text-gray-900">{run.label}</h3>
          <p className="mt-0.5 text-xs text-gray-500">{locations.length} locations</p>
        </div>
        <button type="button" onClick={onClose} className="rounded-md p-1 text-gray-500 hover:bg-gray-100"><XMarkIcon className="h-4 w-4" /></button>
      </div>
      <div className="thin-scroll flex-1 overflow-y-auto p-3">
        <div className="overflow-hidden rounded-md border border-gray-200">
          {[...shelvingGroups.entries()].map(([section, rows]) => <section key={`shelving-${section}`} className="border-b border-gray-200 p-2.5 last:border-b-0">
            <p className="text-xs text-gray-600">B-{String(section).padStart(2, '0')} is shelving section {section}; the approved frame holds sections 01-08 on the B face and 09-13 on the SM face. Needs Bryan&apos;s physical mapping.</p>
            {rows.map((location) => <button type="button" key={location.location_code} onClick={() => onSelectLocation(location)} className="mt-1 flex w-full items-center gap-2 rounded px-1.5 py-1.5 text-left hover:bg-gray-50">
              <span className="min-w-0 flex-1"><span className="block truncate text-xs font-medium text-gray-900">{location.location_code}</span><span className="mt-0.5 block text-[11px] text-gray-500">Bay {String(location.placement?.bay || '?').padStart(2, '0')} · Level {location.placement?.level || '?'}</span></span>
              <span className={`shrink-0 rounded px-1.5 py-1 text-[10px] font-medium ${availabilityClass(location.availability_state)}`}>{location.availability_state || 'Unknown'}</span>
            </button>)}
          </section>)}
          {genericLocations.map((location) => (
            <button type="button" key={location.location_code} onClick={() => onSelectLocation(location)} className="flex w-full items-center gap-2 border-b border-gray-200 px-2.5 py-2.5 text-left last:border-b-0 hover:bg-gray-50">
              <span className="min-w-0 flex-1">
                <span className="block truncate text-xs font-medium text-gray-900">{location.location_code}</span>
                <span className="mt-0.5 block text-[11px] text-gray-500">Bay {String(location.placement?.bay || '?').padStart(2, '0')} · Level {location.placement?.level || '?'}</span>
                {location.placement?.level > 5 && <span className="mt-0.5 block text-[11px] text-gray-500">Level F/G/H is outside the approved structure.</span>}
                {location.placement?.bin > 8 && <span className="mt-0.5 block text-[11px] text-gray-500">Bin 09 and above is outside the approved structure.</span>}
              </span>
              <span className={`shrink-0 rounded px-1.5 py-1 text-[10px] font-medium ${availabilityClass(location.availability_state)}`}>{location.availability_state || 'Unknown'}</span>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default OutsideStructureDrawer;
